import type { AssetVisibilityContext, BuxusOperatorPayload } from '@buxus/shared'
import { MapSurface } from './MapSurface'
import type { PipelineMapOperatorDirectoryEntry } from './mapPipelinePopupDom'
import { AssetsMapRailOverlay } from './components/assets/AssetsMapRailOverlay'
import type { ScreenInteractionContext } from './platform/analytics/interactionAnalytics'

type OperatorOverviewMapScreenProps = {
  payload: BuxusOperatorPayload
  resolveContext: AssetVisibilityContext
  stakeholderCode: string | null
  jurisdictionCountyStateKeys: ReadonlySet<string> | null
  pipelineOperatorDirectory?: readonly PipelineMapOperatorDirectoryEntry[]
  onViewPipelineOperator?: (operatorId: string) => void
  onFocusAssetInSidebar: (assetId: string) => void
  contextAssetId?: string | null
  analytics?: ScreenInteractionContext
}

export function OperatorOverviewMapScreen({
  payload,
  resolveContext,
  stakeholderCode,
  jurisdictionCountyStateKeys,
  pipelineOperatorDirectory,
  onViewPipelineOperator,
  onFocusAssetInSidebar,
  contextAssetId = null,
  analytics,
}: OperatorOverviewMapScreenProps) {
  return (
    <MapSurface variant="fluid" className="operator-overview-map-surface">
      <AssetsMapRailOverlay
        payload={payload}
        resolveContext={resolveContext}
        stakeholderCode={stakeholderCode}
        jurisdictionCountyStateKeys={jurisdictionCountyStateKeys}
        pipelineOperatorDirectory={pipelineOperatorDirectory}
        onViewPipelineOperator={onViewPipelineOperator}
        onFocusAssetInSidebar={onFocusAssetInSidebar}
        contextAssetId={contextAssetId}
        mapKey="map-operator-overview"
        hostClassName="operator-overview-map-host"
        analytics={analytics}
      />
    </MapSurface>
  )
}
